<div [formGroup]="form" class="gup-C-dateRange gup-C-flexGroup -row -nowrap -justifyBetween -alignCenter">

    <kal-form-field>

        <div class="gup-C-dateRange__dateDeb gup-C-flexGroup__item -demi">

            <kal-datepicker
                [id]="id + '_start_date'"
                [label]="controlLabel"
                [placeholder]="startPlaceholder"
                [required]="required"
                formControlName="startDate">
            </kal-datepicker>

        </div>

    </kal-form-field>

    <div *ngIf="!displayDateEnd; else displayDateEndInputs"
         class="gup-C-dateRange__link gup-C-flexGroup__item">

        <a (click)="toggleDateEnd()"
           *ngIf="!displayDateEnd"
           class="gup-O-link -secondary">
            {{ addDatesLabel }}
        </a>

    </div>

    <ng-template #displayDateEndInputs>

        <div class="gup-C-flexGroup__item gup-C-dateRange__text">{{betweenLabel}}</div>

        <kal-form-field>

            <div class="gup-C-dateRange__dateFin gup-C-flexGroup__item -demi ">

                <kal-datepicker [placeholder]="endPlaceholder"
                                formControlName="endDate"
                                [id]="id + '_end_date'">
                </kal-datepicker>

            </div>

        </kal-form-field>

    </ng-template>

</div>
